module.exports = __webpack_public_path__ + "media/images/lb/126-4d65e3eaac8c50895ba8f9f7a3bdebc3.svg";